
Monet.TabControl = {

    closeActions: {},
    subscribeCloseAction: function(key, closeAction) {
        this.closeActions[key] = closeAction;
    },
    unSubscribeCloseAction: function(key) {
        delete this.closeActions[key];
    },

    expandActions: {},
    subscribeExpandAction: function(key, expandAction) {
        this.expandActions[key] = expandAction;
    },
    unSubscribeExpandAction: function(key) {
        delete this.expandActions[key];
    },

    init: function (customActionsOnClose) {

        var that = this;

        var $tabs = $("#tabs").tabs({
            tabTemplate: "<li><a href='#{href}' rel=''>#{label}</a> <span class='ui-icon ui-icon-extlink'>Open Window</span><span class='ui-icon ui-icon-close'>Remove Tab</span></li>"
        }).find(".ui-tabs-nav").sortable({
            axis: "x",
            stop: function() {
              $("#tabs").tabs( "refresh" );
            }
        });

        $("#tabs span.ui-icon-close").die("click");

        $("#tabs span.ui-icon-close").live("click", function () {
            var name = $(this).parents().attr('aria-controls');

            var index = that.getTabIndex(name);

            //Limpa todo o conteúdo da aba antes de destruir ela
            $($(this).parents().find("a:first").attr("href")).removeWithLeakage();

            $($(this).parents().find("a:first").attr("href")).html("");

            if (customActionsOnClose) {
                customActionsOnClose();
            }

            var closeAction = Monet.TabControl.closeActions[name];
            if( closeAction ) {
                closeAction();
            }

            var $tabs = $("#tabs");
            //Remove a aba
            $tabs.tabs("remove", index);

            var activeIndex = $tabs.tabs( "option", "active" );
            var href = "#";
            if(activeIndex > -1) {
                href = $tabs.tabs({
                        active: activeIndex
                     })
                    .find("a")
                    .attr("href");
            }
            App.Objects.Users.navigate(href, false);

        });

        $(".ui-icon-extlink").die("click");

        $(".ui-icon-extlink").live("click", function (e) {
            var link = $(e.currentTarget).prev();
            var href = link.attr("href");
            var expandAction = Monet.TabControl.expandActions[ href.replace("#", "") ];
            if( href.match(/\help/g) && expandAction ) {
                window.open(expandAction().replace(/\"/g, ""), 'mywin', 'left=0,top=0,toolbar=yes,location=yes,directories=yes,status=no,menubar=yes,scrollbars=yes,copyhistory=no,resizable=yes');
            } else {
                window.open(link.attr('rel'), 'mywin', 'left=0,top=0,toolbar=yes,location=yes,directories=yes,status=no,menubar=yes,scrollbars=yes,copyhistory=no,resizable=yes');
            }

        });

        $("#tabs").tabs('paging', { cycle: true, nextButton: '<div class="tabNext"></div>', prevButton: '<div class="tabPrevius"></div>' });

        return this;

    },

    getTabIndex : function (name) {
        const listTabsEl = document.querySelector('.gmTabs__tab-bar .scrolled');

        if(!listTabsEl) {
            return null;
        }

       const listTabs = listTabsEl.childNodes;

        for (var i = 0; i < listTabs.length; i++) {
            if ( listTabs[i].firstChild.getAttribute('data-live-key') === name ){
                return i;
            }
        }

    },

    addNewTab: function (tab_name, tab_title, call_back, keyPermission) {

        if (!Monet.Session.isLogged) {
            window.location = "#";
        }

        const have_tab = $("#" + tab_name);
        let screens = {};

        if (have_tab.length === 0) {

            if (Monet.Session.Security && Monet.Session.Security.screens) {
                screens = Monet.Session.Security.screens;
            }

            if (screens.hasOwnProperty(tab_name) || Monet.Security.checkKeyIsEnabled(keyPermission)) {

                new Monet.TabControl.createTab(tab_name, tab_title, call_back);

            } else {
                window.location = '#/AccessDenied/401';
            }

        } else {

            if (typeof call_back !== "undefined") {
                call_back();
            }

        }

        Monet.I18n.translateInterface();

        return this;

    },

    createTab: function (tab_name, tab_title, call_back) {

        $("#tabs").tabs("add", "#" + tab_name, tab_title);

        $("#" + tab_name).css("display", "block");

        $("#tabs").tabs({
            selected: $('#tabs > div').tabs().length - 1
        });

        $("a[href='#" + tab_name + "']").attr("rel", window.location);

        if (typeof call_back !== "undefined") {
            call_back();
        }

        if (typeof Monet.Session.mainMap !== "undefined" && Monet.Session.mainMap.map) {
            Monet.Session.mainMap.map.invalidateSize();
        }

        return this;

    },

    selectTab: function (tabName) {
        $("#tabs").tabs("select", tabName);
    }

};
